import React from 'react'
import { IoIosRemove } from "react-icons/io";
import { IoIosAdd } from "react-icons/io";
import axios from 'axios'
import  { useState  } from 'react'
function AddVehicle() {
    const [isToggled, setIsToggled] = useState(true);
  const handleChange = () => {
    setIsToggled(!isToggled);
    setIsToggled2(true);
    setIsToggled3(true);
    setIsToggled4(true);
  };
  const [isToggled2, setIsToggled2] = useState(true);
  const handleChange2 = () => {
    setIsToggled2(!isToggled2);
    setIsToggled3(true);
    setIsToggled4(true);
    
    setIsToggled(true);
  };
  const [isToggled3, setIsToggled3] = useState(true);
  const handleChange3 = () => {
    setIsToggled3(!isToggled3);
    setIsToggled2(true);
    setIsToggled4(true);
    
    setIsToggled(true);
  };
  const [isToggled4, setIsToggled4] = useState(true);
  const handleChange4 = () => {
    setIsToggled4(!isToggled4);
    setIsToggled2(true);
    setIsToggled3(true);
    
    setIsToggled(true);
  };
  const senddata = (e) => {
    e.preventDefault();
    const formDataofvehicledata = new FormData();
    const formDataofownerdata = new FormData();
    const formDataofregistrationdata = new FormData();
    const formDataofpermitdata = new FormData();

    formDataofvehicledata.append('vehiclenumber', e.target[0].value);
    formDataofvehicledata.append('chassisnumber', e.target[1].value);
    formDataofvehicledata.append('enginenumber', e.target[2].value);
    formDataofvehicledata.append('manufacturer', e.target[3].value);
    formDataofvehicledata.append('makermodel', e.target[4].value);
    formDataofvehicledata.append('vehicleclass', e.target[5].value);
    formDataofvehicledata.append('fueltype', e.target[6].value);
    formDataofvehicledata.append('color', e.target[7].value);
    formDataofvehicledata.append('iscctive', e.target[8].value);

    formDataofownerdata.append('ownername', e.target[9].value);
    formDataofownerdata.append('ownercontact', e.target[10].value);
    formDataofownerdata.append('owneraddress', e.target[11].value);
    formDataofownerdata.append('ownership', e.target[12].value);
    formDataofownerdata.append('ownertype', e.target[13].value);
    formDataofownerdata.append('isactive', e.target[14].value);

    formDataofregistrationdata.append('registrationnumber', e.target[15].value);
    formDataofregistrationdata.append('registrationdate', e.target[16].value);
    formDataofregistrationdata.append('registrationrto', e.target[17].value);
    formDataofregistrationdata.append('rcstatus', e.target[18].value);

    formDataofpermitdata.append('permitnumber', e.target[19].value);
    formDataofpermitdata.append('permitholdername', e.target[20].value);
    formDataofpermitdata.append('permitholderaddress', e.target[21].value);
    formDataofpermitdata.append('permitvehicletype', e.target[22].value);
    formDataofpermitdata.append('permitvalidfrom', e.target[23].value);
    formDataofpermitdata.append('permitvalidto', e.target[24].value);
    formDataofpermitdata.append('permitroutefrom', e.target[25].value);
    formDataofpermitdata.append('permitrouteto', e.target[26].value);

    axios.post(process.env.REACT_APP_API_URL+'/api/Vehicle',formDataofvehicledata).then((response) => {
        console.log(response);
    }
    ).catch((error) => {
        console.error(error);
    });
    axios.post(process.env.REACT_APP_API_URL+'/api/Owner',formDataofownerdata).then((response) => {
        console.log(response);
    }
    ).catch((error) => {
        console.error(error);
    });
    axios.post(process.env.REACT_APP_API_URL+'/api/Registration',formDataofregistrationdata).then((response) => {
        console.log(response);
    }
    ).catch((error) => {
        console.error(error);
    });
    axios.post(process.env.REACT_APP_API_URL+'/api/Permit',formDataofpermitdata).then((response) => {
        console.log(response);
    }
    ).catch((error) => {
        console.error(error);
    });


  }
  return (
    <>
     
    <h1 className=" text-3xl font-semibold text-gray-900 m-3 " align='center'>New Vehicle</h1>
    <div className=" w-full p-5">
      <form className=' w-full Vehicledetails '>
            <div className=" flex justify-center w-full">
                
                <div className=" w-full borderforform  ">  
                
                    <div className='flex m-2'>         
                           <h2 className="text-lg font-semibold ml-3 relative ">Vehicle Details</h2>
    
                           <button onClick={handleChange} className={`ioioremove ${isToggled ? 'on' : 'off'}`}>
                                {isToggled ? <IoIosAdd /> : <IoIosRemove />}
                                </button>
                            </div>
                            <div className={` ${isToggled ? 'hidden' : 'checkbun'}`}>
                           
                                    <div className='flex w-full '>
                                        <div className=" p-6 items-center align-middle w-1/2">
                                        <label className="text-sm font-normal ml-3 mt-2">Vehicle Number</label>
                                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Vehicle Number" required/>
                                        </div>
                                        <div className=" p-6 items-center align-middle w-1/2">
                                        <label className="text-sm font-normal ml-3 mt-2">Chasis Number</label>
                                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Chasis Number" required/>
                                        </div>
                                        <div className=" p-6 items-center align-middle w-1/2">
                                        <label className="text-sm font-normal ml-3 mt-2">Engine Number</label>
                                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Engine Number" required/>
                                        </div>
                                    </div>
                          
                               
                                
                     
                     
               
                      
                      <div className='flex w-full'>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Manufacturer</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Manufacturer" required/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Maker Model</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Maker Model" required/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Vehicle Class</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Vehicle Class" required/>
                        </div>
                      </div>
                     <div className='flex w-full'>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Fuel Type</label>
                        <select className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Fuel Type" required>
                            <option value="Petrol">Petrol</option>
                            <option value="Diesel">Diesel</option>
                            <option value="Electric">Electric</option>
                            <option value="Hybrid">Hybrid</option>
                        </select>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Color</label>
                        <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Color" required/>
                        </div>
                        <div className=" p-6 items-center align-middle w-1/2">
                        <label className="text-sm font-normal ml-3 mt-2">Is Active</label>
                        <select className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Is Active" required>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                        </div>
                    </div>
                    </div>
                </div>
            </div> 
                    <div className=' w-full borderforform mt-5'>
                        <div className='flex mt-2 ml-5 mr-2 mb-2'>
                        <h2 className="text-lg font-semibold relative">Owner Details</h2>
                        <button onClick={handleChange2} className={`ioioremove ${isToggled2 ? 'on' : 'off'}`}>
                                {isToggled2 ? <IoIosAdd /> : <IoIosRemove />}
                                </button>
                        </div>
                        <div className={` ${isToggled2 ? 'hidden' : 'checkbun'}`}>
                        <div className='flex w-full'>
                            <div className=" p-6 items-center align-middle w-1/2">
                                <label className="text-sm font-normal ml-3 mt-2">Owner Name</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Owner Name" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Owner Contact</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Owner Contact" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Owner Address</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Owner Address" required/>
                            </div>
                        </div>
                        <div className='flex w-full'>
                            <div className=" p-6 items-center align-middle w-1/2">
                             <label className="text-sm font-normal ml-3 mt-2">Ownership</label>
                                <select className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Ownership" required>
                                     <option value="Individual">Individual</option>
                                      <option value="Company">Company</option>
                                </select>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Owner Type</label>
                                <select className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Owner Type" required>
                                        <option value="Lease">Lease</option>
                                        <option value="Rent">Rent</option>
                                        <option value="Own">Own</option>
                                 </select>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Is Active</label>
                                <select className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Is Active" required>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            </div>
                            </div>
                    </div> 
                    <div className=' w-full borderforform mt-5'>
                    <div className='flex mt-2 ml-5 mr-2 mb-2'>
                        <h2 className="text-lg font-semibold relative">Registration Details</h2>
                        <button onClick={handleChange3} className={`ioioremove ${isToggled3 ? 'on' : 'off'}`}>
                                {isToggled3 ? <IoIosAdd /> : <IoIosRemove />}
                                </button>
                        </div>
                        <div className={` ${isToggled3 ? 'hidden' : 'checkbun'}`}>
                        <div className='flex w-full'>
                            <div className=" p-6 items-center align-middle w-1/2">
                                <label className="text-sm font-normal ml-3 mt-2">Registration Number</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Registration Number" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Registration Date</label>
                                <input type="date" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Registration Date" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Registration RTO</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Registration RTO" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">RC Status</label>
                                <select className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="RC Status" required>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                        </div>
                        </div>
                    </div>   

                    <div className=' w-full borderforform mt-5'>
                    <div className='flex mt-2 ml-5 mr-2 mb-2'>
                        <h2 className="text-lg font-semibold relative">Vehical Permit Number</h2>
                        <button onClick={handleChange4} className={`ioioremove ${isToggled4 ? 'on' : 'off'}`}>
                                {isToggled4 ? <IoIosAdd /> : <IoIosRemove />}
                                </button>
                        </div>
                        <div className={` ${isToggled4 ? 'hidden' : 'checkbun'}`}>
                        <div className='flex w-full'>
                            <div className=" p-6 items-center align-middle w-1/2">
                                <label className="text-sm font-normal ml-3 mt-2">Permit Number</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Permit Number" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Permit Holder Name</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Permit Holder Name" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Permit Holder Address</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Permit Holder Address" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Permit Vehicle Type</label>
                                <select className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Permit Vehicle Type" required>
                                    <option value="Goods">Goods</option>
                                    <option value="Passenger">Passenger</option>
                                </select>
                            </div>
                        </div>

                        <div className='flex w-full'>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Permit Valid From</label>
                                <input type="date" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Permit Valid From" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Permit Valid To</label>
                                <input type="date" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Permit Valid To" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Permit Route From</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Permit Route" required/>
                            </div>
                            <div className=' p-6 items-center align-middle w-1/2'>
                                <label className="text-sm font-normal ml-3 mt-2">Permit Route To</label>
                                <input type="text" className="border border-gray-200 rounded-md w-11/12 m-3 p-2" placeholder="Permit Route" required/>
                            </div>
                        </div>
                        </div>
                        </div>
                        <button className="rounded-md bg-lime-500 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2  m-3 relative addvehiclebutton"  type="button" onClick={senddata}>Submit</button>
                            
                
            
      </form>
    </div>
    </>
  )
}

export default AddVehicle